module.exports = __webpack_public_path__ + "static/media/bombsIcon.8523ffc0.svg";